// extracted by mini-css-extract-plugin
export var centered = "_r-6";
export var flexible = "_r-5";
export var footer = "_r-k";
export var footerBorder = "_r-l";
export var header = "_r-c";
export var headerBorder = "_r-d";
export var headerDefault = "_r-g";
export var headerMedium = "_r-h";
export var headerPadding = "_r-e";
export var iconAndTitle = "_r-f";
export var large = "_r-4";
export var largePadding = "_r-a";
export var medium = "_r-3";
export var mediumPadding = "_r-9";
export var modal = "_r-0";
export var modalContainer = "_r-b";
export var noPadding = "_r-7";
export var skinny = "_r-1";
export var small = "_r-2";
export var smallPadding = "_r-8";
export var subtitle = "_r-j";
export var title = "_r-i";